var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.$store.getters.isLoggedIn)?_c('NewsFeeds'):_c('Welcome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }